import React from 'react';
import styles from '../styles/components/Layout.module.css';

const BrandingFooter = () => {
  return (
    <footer>
      <p>Powered by Mpulse Ignite (PES Modern College Of Engineering)</p>
    </footer>
  );
};

export default BrandingFooter;
